@if (notifications?.length) {
  <div class="frogo-notifications fk-p5">
    <div class="frogo-notifications--list">
      @for (notification of notifications; track notification.createdAt) {
        <div class="fk-mb3">
          <fk-toast
            [severity]="notification.type"
            [title]="notification.title"
            [text]="notification.message"
            [liveTime]="notification.liveTime"
            (closed)="notificationClosed(notification.createdAt)"></fk-toast>
        </div>
      }
    </div>

    @if (notifications.length > 1) {
      <div class="frogo-notifications--actions-container">
        <button
          class="fk-btn fk-btn-small fk-btn-tertiary"
          (click)="removeAllNotifications()">
          {{ 'notifications.removeAllBtnLabel' | translate }}
        </button>
      </div>
    }
  </div>
}